export const Form = {
    hasError: (object, name) =>
    {
        return Object.prototype.hasOwnProperty.call(object, name);
    },

    containsError: (object, name) => {
        const keys = Object.keys(object);
        let hasError = false;

        keys.forEach(row => {
            if (row.includes(name)) hasError = true;
        });

        return hasError;
    },

    toData: (object) =>
    {
        const formData = new FormData();
        
        for(let key in object)
        {
            formData.append(key, object[key]);
        }

        return formData;
    },
};
